import React from 'react'
import { FaTags} from "react-icons/fa";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

export const Blog = () => {
      const responsive = {
            superLargeDesktop: {
              breakpoint: { max: 4000, min: 3000 },
              items: 3,
            },
            desktop: {
              breakpoint: { max: 3000, min: 1024 },
              items: 3,
            },
            tablet: {
              breakpoint: { max: 992, min:767 },
              items: 2,
            },
            mobile: {
              breakpoint: { max: 464, min: 0 },
              items: 1,
            },
          };
  return (
     <section className="blog m-top m-btm">
          <div className="container">
                  <div className="heading-box flex align-center spce-btwn">
                      <div className="heading">
                            <span className="title">From The Blog</span>
                            <h2>Latest News & Articles</h2>
                      </div>
                     <div className="visit-btn">
                         <a href="/" className="glbl-btn">View All Blogs</a>
                     </div>
                  </div>
                  <Carousel responsive={responsive} infinite={true} autoPlaySpeed={3000} arrows={false} autoPlay={true}>
                  <div className="blogWrap">
                              <div className="img">
                                    <img src="./Assets/img/blog1.jpg" alt="blog"  className="img-fluid"/>
                              </div>
                              <div className="blog-txt">
                                    <div className="top-sec">
                                       <FaTags/>  Technology
                                    </div>
                                    <h3>Discovery incommode earnestly commanded mentions.</h3>
                                    <div className="flex blog-wrt-name space-btwn align-center">
                                          <div className="left">
                                                <img src="./Assets/img/blog-min1.jpg" alt="blog-min" />
                                          </div>
                                          <div className="right">
                                                <h5>Mutuali Bintha</h5>
                                                <span>January 25, 2022</span>
                                          </div>

                                    </div>

                              </div>

                  </div>
                  <div className="blogWrap">
                              <div className="img">
                                    <img src="./Assets/img/blog1.jpg" alt="blog"  className="img-fluid"/>
                              </div>
                              <div className="blog-txt">
                                    <div className="top-sec">
                                       <FaTags/>  Technology
                                    </div>
                                    <h3>Discovery incommode earnestly commanded mentions.</h3>
                                    <div className="flex blog-wrt-name space-btwn align-center">
                                          <div className="left">
                                                <img src="./Assets/img/blog-min1.jpg" alt="blog-min" />
                                          </div>
                                          <div className="right">
                                                <h5>Mutuali Bintha</h5>
                                                <span>January 25, 2022</span>
                                          </div>

                                    </div>

                              </div>

                  </div>
                  <div className="blogWrap">
                              <div className="img">
                                    <img src="./Assets/img/blog1.jpg" alt="blog"  className="img-fluid"/>
                              </div>
                              <div className="blog-txt">
                                    <div className="top-sec">
                                       <FaTags/>  Technology
                                    </div>
                                    <h3>Discovery incommode earnestly commanded mentions.</h3>
                                    <div className="flex blog-wrt-name space-btwn align-center">
                                          <div className="left">
                                                <img src="./Assets/img/blog-min1.jpg" alt="blog-min" />
                                          </div>
                                          <div className="right">
                                                <h5>Mutuali Bintha</h5>
                                                <span>January 25, 2022</span>
                                          </div>

                                    </div>

                              </div>

                  </div>
                  <div className="blogWrap">
                              <div className="img">
                                    <img src="./Assets/img/blog1.jpg" alt="blog"  className="img-fluid"/>
                              </div>
                              <div className="blog-txt">
                                    <div className="top-sec">
                                       <FaTags/>  Technology
                                    </div>
                                    <h3>Discovery incommode earnestly commanded mentions.</h3>
                                    <div className="flex blog-wrt-name space-btwn align-center">
                                          <div className="left">
                                                <img src="./Assets/img/blog-min1.jpg" alt="blog-min" />
                                          </div>
                                          <div className="right">
                                                <h5>Mutuali Bintha</h5>
                                                <span>January 25, 2022</span>
                                          </div>

                                    </div>

                              </div>

                  </div>
                  </Carousel>
          </div>
     </section>
  )
}
